/**
 * @legacy
 * @compat need to load jquery fully before importing other module to be able
 *         to expose jQuery at `window` top-level
 */
import jQuery from "jquery"
Object.assign(window, { $: jQuery, jQuery })
